import { Box, Slide, Typography } from '@mui/material'
import React from 'react'
import { TransitionGroup } from 'react-transition-group'
import { ChallengeEntry, MMChallengeType } from '../../store/types'
import { ChallengeCard, RatingType } from './ChallengeCard'

export enum ChallengeVariant {
    MY_CHALLENGES = 'My Challenges',
    OPEN_CHALLENGES = 'Open Challenges',
    DIRECT_CHALLENGES = 'Direct Challenges',
    VIEW_CHALLENGE = 'View Challenge',
}

export interface ChallengesProps {
    variant: ChallengeVariant
    challenges: ChallengeEntry[]
    handleAction: (challenge: ChallengeEntry) => void
    // an accept is in flight: no card takes another tap, this one shows progress
    pendingChallengeId?: string
}

export const Challenges: React.FC<ChallengesProps> = ({ variant, challenges, handleAction, pendingChallengeId }) => {
    const challengeAction = (event, challenge: ChallengeEntry) => {
        event.preventDefault()
        handleAction(challenge)
    }

    const modifyPlayerInfo = (challenge: ChallengeEntry) => {
        if (variant === ChallengeVariant.MY_CHALLENGES && challenge.challengeType === MMChallengeType.CUSTOM) {
            const rating = challenge.ratingRange
                ? challenge.ratingRange.from === 0 && challenge.ratingRange.to === 9999
                    ? 'Any'
                    : `${challenge.ratingRange.from}-${challenge.ratingRange.to}`
                : 0

            return {
                ...challenge,
                challengee: {
                    ...challenge.challengee,
                    username: 'Any Opponent',
                    avatarUrl: '/random-user-avatar.svg',
                    rating,
                    is_provisional: false,
                    nationality: undefined!,
                    botdRewardUrl: undefined!,
                    title: undefined!,
                },
            }
        } else {
            return challenge
        }
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            {Boolean(challenges.length) && <Typography variant="h5">{variant}</Typography>}
            <TransitionGroup style={{ display: 'flex', flexDirection: 'column' }}>
                {challenges.map((challenge) => {
                    const modifiedChallenge = modifyPlayerInfo(challenge)
                    // Determine which player is being used
                    const isMyChallenge = variant === ChallengeVariant.MY_CHALLENGES && modifiedChallenge.challengee
                    const player = isMyChallenge ? modifiedChallenge.challengee : modifiedChallenge.challenger

                    if (!player) {
                        return null
                    }

                    // Set up player
                    const updatedPlayer = {
                        ...player,
                        nationality: player.nationality === '' ? 'WORLD' : player.nationality,
                        color: challenge.challengerColor,
                        reward: {
                            tier: player.reward?.tier ?? 0,
                            season: player.reward?.season ?? '',
                        },
                    }

                    return (
                        <Slide key={challenge.challengeId} direction="left">
                            <div>
                                <ChallengeCard
                                    variant={variant}
                                    ratingType={challenge.timeMode.name as RatingType}
                                    type={isMyChallenge ? 'invite' : 'challenge'}
                                    challenge={challenge}
                                    player={updatedPlayer}
                                    handleAction={(event) => challengeAction(event, challenge)}
                                    actionDisabled={!!pendingChallengeId}
                                    pending={challenge.challengeId === pendingChallengeId}
                                />
                            </div>
                        </Slide>
                    )
                })}
            </TransitionGroup>
        </Box>
    )
}
